import React, { useEffect, useState, useRef, createElement } from 'react';
import { X, User, Mail, Phone, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+39',
  country: 'Italia'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function LeadMagnetHeyLloydDemoPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const nameInputRef = useRef<HTMLInputElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const areaCodeRef = useRef<HTMLSelectElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const domName = nameInputRef.current?.value?.trim() || name.trim();
    const domEmail = emailInputRef.current?.value?.trim() || email.trim();
    const domPhone = phoneInputRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    const domAreaCode = areaCodeRef.current?.value || areaCode;
    if (!domName || domName.length < 2) {
      alert('Por favor ingresa tu nombre completo');
      return;
    }
    if (!domEmail || !domEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!domPhone || domPhone.length < 7) {
      alert('Por favor ingresa tu número de teléfono');
      return;
    }
    setIsSubmitting(true);
    try {
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      const payload = {
        name: domName,
        email: domEmail,
        phone: `${domAreaCode}${domPhone}`,
        first_name: domName.split(' ')[0],
        last_name: domName.split(' ').slice(1).join(' ') || domName.split(' ')[0],
        full_name: domName,
        source: '/lead-magnet-heylloyd-demo',
        page_path: '/lead-magnet-heylloyd-demo',
        event_time: Math.floor(Date.now() / 1000),
        action_source: 'website'
      };
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      navigate('/thank-you');
    } catch (error) {
      console.error('Error submitting form:', error);
      navigate('/thank-you');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden selection:bg-[#00f7fc] selection:text-black" data-id="element-1786">
      <noscript data-id="element-1787">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-1788" />
      </noscript>

      <VslHeader data-id="element-1789" />

      <main className="relative z-10 max-w-3xl mx-auto px-4 py-12 md:py-20" data-id="element-1790">
        <article className="prose prose-invert prose-lg md:prose-xl max-w-none" data-id="element-1791">
          <h1 className="text-3xl md:text-5xl font-black leading-tight tracking-tight mb-8 text-white" data-id="element-1792">
            El Protocolo de 48 Horas: Cómo la IA Construye Negocios Rentables
            Mientras Duermes
          </h1>

          <div className="space-y-6 text-gray-300 leading-relaxed" data-id="element-1793">
            <p data-id="element-1794">
              Si estás leyendo esto, probablemente ya intentaste crear un
              negocio digital. Y probablemente te topaste con el mismo muro que
              el 99% de las personas: la parálisis técnica.
            </p>

            <p data-id="element-1795">
              No sabes qué vender. No sabes cómo hacer una página web. No sabes
              cómo escribir anuncios que conviertan. Y la idea de pasar meses
              aprendiendo todo esto te agota antes de empezar.
            </p>

            <p data-id="element-1796">
              Aquí está la verdad incómoda: Los emprendedores que están
              facturando $10k, $50k o $100k al mes no son más inteligentes que
              tú. Simplemente dejaron de hacer el trabajo manual.
            </p>

            <p data-id="element-1797">
              Hoy, la barrera de entrada es cero. Lo que antes requería un
              equipo de cinco personas y tres meses de trabajo, ahora se ejecuta
              en 48 horas con una sola herramienta de Inteligencia Artificial:
              HEYLLOYD.
            </p>

            <h2 className="text-2xl md:text-3xl font-bold text-white mt-12 mb-8" data-id="element-1798">
              Así es exactamente como funciona el sistema (sin experiencia
              previa):
            </h2>

            <div className="space-y-8" data-id="element-1799">
              <div data-id="element-1800">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-1801">
                  <span className="text-[#00f7fc]" data-id="element-1802">1.</span> La IA Encuentra el
                  Dinero (Minuto 1-15)
                </h3>
                <p data-id="element-1803">
                  Olvídate de adivinar qué quiere la gente. HEYLLOYD escanea
                  millones de datos en tiempo real y te dice exactamente qué
                  nicho está hambriento hoy, qué problema tienen y cuánto están
                  dispuestos a pagar por la solución. Tienes la certeza
                  matemática antes de empezar.
                </p>
              </div>

              <div data-id="element-1804">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-1805">
                  <span className="text-[#00f7fc]" data-id="element-1806">2.</span> La IA Crea el
                  Producto (Hora 1-3)
                </h3>
                <p data-id="element-1807">
                  No necesitas ser un experto. Basado en la demanda detectada,
                  HEYLLOYD estructura y redacta el producto digital completo
                  (una guía, un curso, un sistema) diseñado específicamente para
                  resolver ese problema urgente.
                </p>
              </div>

              <div data-id="element-1808">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-1809">
                  <span className="text-[#00f7fc]" data-id="element-1810">3.</span> La IA Construye la
                  Máquina de Ventas (Hora 4-6)
                </h3>
                <p data-id="element-1811">
                  Aquí es donde la mayoría se rinde. HEYLLOYD usa su función
                  Sales Letter Weapon para redactar y ensamblar una página de
                  ventas de alta conversión. Escribe el titular, la historia, la
                  oferta y los bonos usando fórmulas psicológicas probadas. Cero
                  código. Cero diseño.
                </p>
              </div>

              <div data-id="element-1812">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-1813">
                  <span className="text-[#00f7fc]" data-id="element-1814">4.</span> La IA Genera los
                  Anuncios (Hora 7-8)
                </h3>
                <p data-id="element-1815">
                  No necesitas grabar videos complicados ni pagar diseñadores.
                  La IA te entrega los guiones exactos para Meta y TikTok, y
                  genera las imágenes publicitarias diseñadas para detener el
                  scroll y conseguir clics baratos.
                </p>
              </div>

              <div data-id="element-1816">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-1817">
                  <span className="text-[#00f7fc]" data-id="element-1818">5.</span> El Lanzamiento
                  (Hora 48)
                </h3>
                <p data-id="element-1819">
                  Conectas las piezas, enciendes los anuncios y dejas que el
                  sistema trabaje. Pasaste de una idea en blanco a un negocio
                  operando en el mercado en menos de un fin de semana.
                </p>
              </div>
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-white mt-12 mb-6" data-id="element-1820">
              El Siguiente Paso (Ver Para Creer)
            </h2>

            <p data-id="element-1821">
              Leer sobre esto es interesante. Verlo suceder en vivo frente a tus
              ojos te cambiará la perspectiva para siempre.
            </p>

            <p data-id="element-1822">
              He preparado un Entrenamiento en Vivo y Gratuito donde voy a
              compartir mi pantalla, abrir HEYLLOYD, y construir un negocio
              completo desde cero, paso a paso, usando exactamente este
              protocolo.
            </p>

            <p data-id="element-1823">
              Vas a ver la investigación, la creación de la oferta y la página
              de ventas en tiempo real. Sin secretos. Sin teoría. Pura
              ejecución.
            </p>

            <div className="mt-12 text-center" data-id="element-1824">
              <button onClick={() => setShowRegisterModal(true)} className="group relative w-full md:w-auto bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-lg md:text-xl uppercase tracking-wide rounded-xl py-5 px-8 shadow-[0_0_40px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-1825">
                Haz clic aquí para registrarte al Entrenamiento en Vivo y ver el
                Sistema en Acción
                <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-1826">
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-1827" />
                </div>
              </button>
              <p className="mt-6 text-gray-400 italic" data-id="element-1828">
                La tecnología ya no es una excusa. Nos vemos dentro.
              </p>
            </div>
          </div>
        </article>
      </main>

      <Footer data-id="element-1829" />

      {/* Registration Modal */}
      {showRegisterModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowRegisterModal(false)} data-id="element-1830">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(253,185,49,0.15)]" onClick={e => e.stopPropagation()} data-id="element-1831">
            <button onClick={() => setShowRegisterModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" data-id="element-1832">
              <X className="w-6 h-6" data-id="element-1833" />
            </button>

            <div className="text-center mb-6" data-id="element-1834">
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase" data-id="element-1835">
                Completa Tu Registro
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-1836">
                Ingresa tus datos para asegurar tu cupo gratuito
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1837">
              {/* Name Input */}
              <div className="space-y-1" data-id="element-1838">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1839">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-1840">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1841">
                    <User className="h-5 w-5 text-gray-500" data-id="element-1842" />
                  </div>
                  <input ref={nameInputRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-1843" />
                </div>
              </div>

              {/* Email Input */}
              <div className="space-y-1" data-id="element-1844">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1845">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-1846">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1847">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-1848" />
                  </div>
                  <input ref={emailInputRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-1849" />
                </div>
              </div>

              {/* Phone Input Group */}
              <div className="space-y-1" data-id="element-1850">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1851">
                  WhatsApp / Teléfono
                </label>
                <div className="flex gap-2" data-id="element-1852">
                  {/* Area Code Selector */}
                  <div className="relative w-1/3" data-id="element-1853">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-1854">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-1855" />
                    </div>
                    <select ref={areaCodeRef} name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-1856">
                      {COUNTRY_CODES.map(country => <option key={country.code} value={country.code} className="bg-gray-900" data-id="element-1857">
                          {country.code} {country.country}
                        </option>)}
                    </select>
                  </div>

                  {/* Phone Number Input */}
                  <div className="relative w-2/3" data-id="element-1858">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1859">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-1860" />
                    </div>
                    <input ref={phoneInputRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-[#FDB931] focus:bg-white/10 transition-all" data-id="element-1861" />
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" disabled={isSubmitting} className="w-full mt-6 bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] disabled:opacity-50 disabled:cursor-not-allowed text-black font-black uppercase tracking-wide rounded-xl py-4 shadow-lg hover:shadow-[#FDB931]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-1862">
                {isSubmitting ? 'PROCESANDO...' : 'CONFIRMAR REGISTRO'}
              </button>

              <p className="text-center text-xs text-gray-500 mt-4" data-id="element-1863">
                Tus datos están 100% seguros y no compartiremos tu información.
              </p>
            </form>
          </div>
        </div>}
    </div>;
}